<template>
  <g>
    <g v-if="rand.a.type === hohlschnitt.title">
      <path :d="'M75 425 q175 -30 350 0 q' + bXhohlschnitt + ' ' + bYhohlschnitt + ' -175 -350 q' + aXhohlschnitt + ' ' + aYhohlschnitt + ' -175 350'" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <polygon v-for="(corner, index) in hohlschnitt.corners" :key="index" :points="corner.point" :transform="'rotate(' + corner.rotate + ')'" stroke="#b1b1b1" stroke-width="2" fill="#fff"/>
    </g>
    <g v-else>
      <polygon points="75,425 425,425 250,75" stroke="#b1b1b1" stroke-width="1" :fill="material.color.hex"/>
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === saum">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="side.rand.oesenArt != inactiveOesen">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === hohlsaum" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === keder" stroke="#b1b1b1" stroke-opacity="0">
          <polygon :points="side.keder.outside" fill="#b1b1b1"/>
          <polygon :points="side.keder.inside" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
    <g v-for="(side, index) in sides" :key="index">
      <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#353535" stroke-width="1"/>
      <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#353535" stroke-width="1" fill="#353535"/>
      <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#353535" stroke-width="1" fill="#353535"/>
    </g>
    <text v-for="side in sides" :key="side.id" :x="side.labelSpace.x" :y="side.labelSpace.y" font-weight="bold" font-family="sans-serif" font-size="2.5em" fill="#232323">{{side.name}}</text>
  </g>
</template>

<script>
import DataRand from './../../../../../data/main/config/setup/rand/randArt'

export default {
  props: ['material', 'rand'],
  data () {
    return {
      aXhohlschnitt: -87.5 + Math.sqrt(720),
      aYhohlschnitt: 175 + 1 / 2 * Math.sqrt(720),
      bXhohlschnitt: -87.5 - Math.sqrt(720),
      bYhohlschnitt: -175 + 1 / 2 * Math.sqrt(720),
      hohlschnitt: {
        title: DataRand.randArt.hohlschnitt.title.name,
        corners: {
          cornerMU: {
            point: '245,80 245,70 255,70',
            rotate: '45 250 75'
          },
          cornerLD: {
            point: '70,420 70,430 80,430',
            rotate: '10 75 425'
          },
          cornerRD: {
            point: '430,420 430,430 420,430',
            rotate: '-10 425 425'
          }
        }
      },
      saum: DataRand.randArt.saum.titleSaum.name,
      hohlsaum: DataRand.randArt.hohlsaum.title.name,
      keder: DataRand.randArt.keder.title.name,
      inactiveOesen: DataRand.randArt.saum.optionsOesenart[0].value.oesenArt
    }
  },
  methods: {
    spaceRand (x, y) {
      return (Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)))
    }
  },
  computed: {
    sides () {
      return {
        a: {
          name: 'a',
          rand: this.rand.a.type,
          oesenAnzahl: this.rand.a.type === this.saum ? this.rand.a.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2 + 75,
            xEnd: 425 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M90 395 L410 395',
          hohlsaum: 'M79.5 416 L420.5 416',
          keder: {
            outside: '75,425 79.5,416 420.5,416 425,425',
            inside: '75,425 76.5,422 423.5,422 425,425'
          },
          labelSpace: {
            x: 245,
            y: 485
          },
          border: {
            line: {
              xStart: 75,
              yStart: 445,
              xEnd: 425,
              yEnd: 445
            },
            corner: {
              start: '75,445 85,440 85,450',
              rotateStart: 'rotate(0, 75, 445)',
              end: '425,445 415,440 415,450',
              rotateEnd: 'rotate(0, 425, 445)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          rand: this.rand.b.type,
          oesenAnzahl: this.rand.b.type === this.saum ? this.rand.b.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2,
            xEnd: 250,
            x: function (i, item) {
              if (item === 1) {
                return ((75 + this.xStart) + this.xEnd) / 2
              } if (item === 2) {
                return (this.xStart + 75) + i * (this.xEnd - (this.xStart + 75))
              } else {
                return (this.xStart + 75) + (i / (item - 1)) * (this.xEnd - (this.xStart + 75))
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return 425 - (2 * (((75 + this.xStart) + this.xEnd) / 2 - 75) - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2)))
              } else if (item === 2) {
                return 410 - i * (2 * (175 - this.xStart))
              } else {
                return 410 - (i / (item - 1)) * (2 * (175 - this.xStart))
              }
            }
          },
          saum: 'M' + (75 + this.spaceRand(15, 30)) + ' 425 L' + (250 + this.spaceRand(15, 30) / 2) + ' ' + (75 + this.spaceRand(15, 30)),
          hohlsaum: 'M' + (75 + this.spaceRand(4.5, 9)) + ' 425 L' + (250 + this.spaceRand(4.5, 9) / 2) + ' ' + (75 + this.spaceRand(4.5, 9)),
          keder: {
            outside: '75,425 ' + (75 + this.spaceRand(4.5, 9)) + ',425 ' + (250 + this.spaceRand(4.5, 9) / 2) + ',' + (75 + this.spaceRand(4.5, 9)) + ' 250,75',
            inside: '75,425 ' + (75 + this.spaceRand(1.5, 3)) + ',425 ' + (250 + this.spaceRand(1.5, 3) / 2) + ',' + (75 + this.spaceRand(1.5, 3)) + ' 250,75'
          },
          labelSpace: {
            x: 100,
            y: 240
          },
          border: {
            line: {
              xStart: 55,
              yStart: 415,
              xEnd: 230,
              yEnd: 65
            },
            corner: {
              start: '55,415 50,405 60,405',
              rotateStart: 'rotate(27, 55, 415)',
              end: '230,65 225,75 235,75',
              rotateEnd: 'rotate(27, 230, 65)'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          rand: this.rand.c.type,
          oesenAnzahl: this.rand.c.type === this.saum ? this.rand.c.oesenAnzahl : 0,
          oesenAbstand: {
            xStart: 250,
            xEnd: 425 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return 425 - (-2 * (this.xStart + this.xEnd - 150) / 2 + 700 - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2)))
              } else if (item === 2) {
                return 425 - (-2 * (this.xStart - 75) + 700 - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) - i * (-2 * (175 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2))
              } else {
                return 425 - (-2 * (this.xStart - 75) + 700 - Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) - (i / (item - 1)) * (-2 * (175 - (15 + Math.sqrt(Math.pow(15, 2) + Math.pow(30, 2))) / 2))
              }
            }
          },
          saum: 'M' + (250 - this.spaceRand(15, 30) / 2) + ' ' + (75 + this.spaceRand(15, 30)) + ' L' + (425 - this.spaceRand(15, 30)) + ' 425',
          hohlsaum: 'M' + (250 - this.spaceRand(4.5, 9) / 2) + ' ' + (75 + this.spaceRand(4.5, 9)) + ' L' + (425 - this.spaceRand(4.5, 9)) + ' 425',
          keder: {
            outside: '250,75 ' + (250 - this.spaceRand(4.5, 9) / 2) + ',' + (75 + this.spaceRand(4.5, 9)) + ' ' + (425 - this.spaceRand(4.5, 9)) + ',425 425,425',
            inside: '250,75 ' + (250 - this.spaceRand(1.5, 3) / 2) + ',' + (75 + this.spaceRand(1.5, 3)) + ' ' + (425 - this.spaceRand(1.5, 3)) + ',425 425,425'
          },
          labelSpace: {
            x: 380,
            y: 240
          },
          border: {
            line: {
              xStart: 445,
              yStart: 415,
              xEnd: 270,
              yEnd: 65
            },
            corner: {
              start: '445,415 440,405 450,405',
              rotateStart: 'rotate(-27, 445, 415)',
              end: '270,65 265,75 275,75',
              rotateEnd: 'rotate(-27, 270, 65)'
            }
          },
          id: 3
        }
      }
    }
  }
}
</script>

<style>
</style>
